import React from "react";


function Contact() {
return (
<section id="contact" className="contact">
<h2>Contact Us</h2>
<p>📍 Address: Main Thana Kalan Road, Near Shri Hari Hospital, Kharkhoda-131402</p>
<p>📞 Phone: +91 9467019164</p>
<p>✉️ Email: <a href="mailto:Biokaredental@gmail.com">Biokaredental@gmail.com</a></p>
<iframe
title="Biokare Location"
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3493.673414943985!2d76.91418298394316!3d28.878330512440993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390da5deecfae67d%3A0x40933f2105c9c8b0!2sBiokare%20Dental%20Clinic!5e0!3m2!1sen!2sus!4v1759321352683!5m2!1sen!2sus"
width="100%"
height="250"
style={{ border: 0 }}
allowFullScreen
loading="lazy"
referrerPolicy="no-referrer-when-downgrade"
/>
</section>
);
}


export default Contact;
